import clsx from 'clsx';
import React from 'react';

import styles from './ButtonGroup.css';

type ButtonGroupProps = {
    children: React.ReactNode;
    direction: 'row' | 'column';
};

const ButtonGroup = ({ children, direction }: ButtonGroupProps) => (
    <div className={clsx([styles.group, direction === 'row' && styles.row])} role='group'>
        {children}
    </div>
);

export default ButtonGroup;
